import { Observable } from "rxjs";

import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ImageService {

    constructor(private http: HttpClient) {}


    public uploadImage(image: File): Observable<HttpResponse<any>> {
        const formData = new FormData();

        formData.append('image', image);

        return this.http.post('/api/v1/image-upload', formData, { observe: 'response' });
    }

}

